const get = path => {
  const baseURL = process.env.REACT_APP_SITE_API || "https://api.global.bible/";
  return fetch(baseURL + path).then(response => response.json());
};

export const fetchSites = ({ query = "", limit = 1000, offset = 0 } = {}) =>
  get(`sites/published?limit=${limit}&offset=${offset}&query=${query}`).then(
    data => data
  );
